var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 75,
    viewBox: "0 0 100 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.6666 0H8.3334C3.7373 0 0 3.7373 0 8.3334V66.6668C0 71.2627 3.7373 75 8.3334 75H91.6668C96.2627 75 100 71.2627 100 66.6666V8.3334C100 3.7373 96.2627 0 91.6666 0Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 37.7978C73.3443 27.9128 90.0652 12.5777 95.5997 7.5C95.7101 7.87466 95.8333 8.24677 95.8333 8.65674V67.2427C95.8333 67.6293 95.7112 67.9775 95.613 68.3333C90.0345 63.0004 73.3083 47.1039 62.5 37.7978Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.635 4.58301C91.9418 4.58301 92.2121 4.69368 92.5 4.75626C85.2909 11.2858 61.3868 32.9278 53.0216 40.3868C52.367 40.9703 51.312 41.6663 50.0007 41.6663C48.6894 41.6663 47.6343 40.9703 46.9776 40.3848C38.6134 32.927 14.7079 11.2839 7.5 4.75664C7.78845 4.69407 8.05933 4.5832 8.36632 4.5832H91.635V4.58301Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38733 68.3333C4.2889 67.9775 4.16699 67.6293 4.16699 67.2427V8.65655C4.16699 8.24658 4.29027 7.87466 4.40063 7.5C9.9329 12.5758 26.6565 27.9123 37.5003 37.7974C26.6915 47.1046 9.96363 63.0029 4.38733 68.3333Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43711 71.2503C8.10513 71.2503 7.80997 71.1337 7.5 71.059C13.2371 65.5453 29.998 49.535 40.5702 40.417C41.9484 41.6774 43.2074 42.8266 44.1998 43.7281C45.9127 45.2872 47.9177 46.1096 50 46.1096C52.0823 46.1096 54.0873 45.287 55.798 43.7301C56.7909 42.8281 58.0508 41.678 59.4298 40.417C70.0026 49.534 86.7612 65.5432 92.5 71.059C92.19 71.1337 91.8953 71.2503 91.5629 71.2503H8.43711Z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7473 39.0484C36.2687 38.595 36.7908 38.1404 37.2887 37.7132C26.4375 27.8556 9.70294 12.5617 4.16699 7.5L35.7473 39.0484ZM95.5999 7.5C90.0618 12.5635 73.3298 27.856 62.4783 37.7136C73.2937 46.9937 90.031 62.846 95.6132 68.1644C95.7117 67.8095 95.8337 67.4623 95.8337 67.0768V8.65354C95.8337 8.2447 95.7101 7.87362 95.5999 7.5ZM55.7108 43.8416C53.9913 45.3922 51.9761 46.2114 49.8834 46.2114C47.7908 46.2114 45.7755 45.3922 44.054 43.8396C43.0565 42.9417 41.7912 41.7972 40.406 40.5419C39.8591 41.0093 39.286 41.5055 38.7085 42.0071L67.9812 71.25H91.6564C91.9905 71.25 92.2868 71.1338 92.5983 71.0595C86.8305 65.566 69.9873 49.6219 59.361 40.5419C57.9749 41.7978 56.7088 42.9433 55.7108 43.8416Z",
    fill: "url(#paint0_linear_4221_28949)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6666 0H8.3334C3.7373 0 0 3.7373 0 8.3334V66.6668C0 71.2627 3.7373 75 8.3334 75H91.6668C96.2627 75 100 71.2627 100 66.6666V8.3334C100 3.7373 96.2627 0 91.6666 0Z",
    fill: "url(#paint1_linear_4221_28949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4221_28949",
    x1: 27.0257,
    y1: -15.331,
    x2: 103.035,
    y2: 60.7544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4221_28949",
    x1: -2.94832,
    y1: 12.8133,
    x2: 102.949,
    y2: 62.1953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.79f7932bda2834da28934660f40c7c1b.svg";
export { ForwardRef as ReactComponent };